import React, { ReactNode } from "react";

interface SectionSubtitleProps {
    children: ReactNode;
}

const SectionSubtitle:React.FC<SectionSubtitleProps> = ({ children }) => {
    return (
        <h4 className="section-subtitle">
            {children}
        </h4>
    )
}

export default SectionSubtitle;